import { ChartAxis, ChartSerie } from "./common-chart";

export class RadarChartDatasource {
  zoomInfo: any;
  title: string;
  series: ChartSerie[];
  dimensions: string[];
  isCurrentTeam: boolean;
}
